"use client"

import { MessageCircle } from "lucide-react"
import { CONTACTS } from "@/lib/contacts"

export function WhatsAppWidget() {
  return (
    <a
      href={CONTACTS.social.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 flex size-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-110 hover:brightness-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#25D366] focus-visible:ring-offset-2"
      aria-label="Написать в WhatsApp"
    >
      {/* Pulse ring */}
      <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-20" />
      <MessageCircle className="relative size-7 fill-white" />
    </a>
  )
}
